const defaultState = {
  list: [],
  item: null,
  sliders: [],
  sliders_loaded: true,
}


const slider_folders = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_SLIDER_FOLDERS':
      return {...state, list: action.data}
    case 'SET_SLIDER_FOLDER':
      return {...state, item: action.data}
    case 'NEW_SLIDER_FOLDER':
      return {
        ...state, 
        list: [...state.list, action.data]
      };
    case 'NEW_SLIDER_FOLDER_SLIDER':
      return {
        ...state, 
        sliders: [...state.sliders, action.data]
      };
    case 'UPDATE_SLIDER_FOLDER_SLIDER':
      return {
        ...state, 
        sliders: state.sliders.map(item => {
          if(item.id == action.data.id){
            return action.data
          }
          return item
        }),
      };  
    case 'DELETE_SLIDER_FOLDER':
      return {
        ...state, 
        list: state.list.filter(item => (item.id != action.data)).map(item => ({...item})),
        item: null,
        sliders: []
      }  
    case 'UPDATE_SLIDER_FOLDER':
      return {
        ...state, 
        list: state.list.map(item => {
          if(item.id == action.data.id){
            return {...action.data};
          }
          return {...item};
        }),
        item: action.data
      }
    case 'GET_SLIDER_FOLDER_SLIDERS':
      return {
        ...state,
        sliders: action.data,
        sliders_loaded: true,
      }
    case 'SET_SLIDER_FOLDER_SLIDERS_LOADED':
      return {
        ...state,
        sliders_loaded: action.data,
      }
    case 'DELETE_SLIDER_FOLDER_SLIDER':
      return {
        ...state,
        sliders: state.sliders.filter(item => item.id != action.data) 
      }
    default:
      return state
  }
}

export default slider_folders;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/slider_folders.js